import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookResponse } from './taf-book';
import { HttpHelper } from '../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookService {

    private _tafBookurl = `api/tafbook`;
    
    constructor(private httpHelper: HttpHelper) { }
    generateTafBook(request:any) :Observable<any>{
        return this.httpHelper.post(`${this._tafBookurl}/tafbookGenerate`, request);
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
            
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
   }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book.service.ts
 **/